import { User } from "./user";

export class TonnageMessage {
    public id?: string;
    public message?: string;
    public tonnageId?: string | null;
    public creationUser?: User;
    public creationDate: Date;

    constructor(tonnageMessage?: TonnageMessage) {
        this.id = tonnageMessage?.id;
        this.message = tonnageMessage?.message;
        this.tonnageId = tonnageMessage?.tonnageId;
        this.creationUser = tonnageMessage?.creationUser;
        this.creationDate = tonnageMessage?.creationDate || new Date();
    }
}
